import { Component, computed, inject, resource } from '@angular/core';
import { RemoteConfigService } from '../../../core/services/remote-config.service';

@Component({
  selector: 'app-floating-chat-button',
  imports: [],
  template: `
    @if (chatUrl(); as url) {
      <a
        [href]="url"
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Abrir chat de soporte por WhatsApp"
        class="fixed bottom-6 right-6 z-50 inline-flex h-14 w-14 items-center justify-center rounded-full bg-[#25D366] text-white shadow-lg shadow-emerald-500/30 transition hover:scale-105 hover:bg-[#1ebe57] hover:shadow-xl focus-visible:outline-none focus-visible:ring-4 focus-visible:ring-emerald-400/50"
      >
        <i class="fa-brands fa-whatsapp text-3xl"></i>
      </a>
    }
  `,
})
export class FloatingChatButtonComponent {
  readonly #remoteConfig = inject(RemoteConfigService);

  readonly #urlResource = resource<string, void>({
    loader: () => this.#remoteConfig.fetchAndGetString('support_chat_url'),
  });

  protected readonly chatUrl = computed(() => {
    const value = this.#urlResource.value()?.trim();
    return value ? value : null;
  });
}
